<app-dialog-template>
  <app-dialog-template-header>
    <app-dialog-template-title>
      {{ 'COMMON.SUMMARY' | translate }}
    </app-dialog-template-title>
  </app-dialog-template-header>
  <app-dialog-template-body>
    <form [formGroup]="form">
      <div class="c-summaries-dialog">
        <ng-container [formArrayName]="'summaryInputs'">
          <ng-container *ngFor="let summaryGroup of summaryGroups; index as i, last as last">
            <ng-container [formGroup]="summaryGroup">
              <div class="grid-x grid-margin-x u-flex-align-items-center">
                <div class="cell small-12 medium-4 xlarge-4 xxxlarge-4">
                  <app-select
                    [isFullWide]="true"
                    [formControlName]="'columnName'"
                    [label]="'SUMMARY.COLUMN_FIELD' | translate"
                    [options]="getSelectOptions(i)"
                    (selectionChanged)="onColumnNameSelectionChanged($event, summaryGroup)">
                  </app-select>
                </div>
                <div class="cell small-12 medium-4 xlarge-4 xxxlarge-4">
                  <app-select
                    [isFullWide]="true"
                    [formControlName]="'summaryType'"
                    [label]="'SUMMARY.SUMMARY_TYPE' | translate"
                    [options]="summaryGroup.controls.columnType.value | setSummaryType">
                  </app-select>
                </div>
                <div class="c-summaries-dialog__actions cell shrink">
                  <app-bui-button-icon
                    [disabled]="summaryGroups.length <= 1"
                    [iconName]="'delete'"
                    [comboStyle]="'settings'"
                    [borderStyle]="'dark'"
                    (clickEvent)="deleteSummaryGroup(i)">
                  </app-bui-button-icon>
                  <ng-container *ngIf="last">
                    <app-bui-button-icon
                      [disabled]="!form.valid"
                      [iconName]="'plus'"
                      [comboStyle]="'settings'"
                      [borderStyle]="'dark'"
                      (clickEvent)="addSummaryGroup()">
                    </app-bui-button-icon>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="c-summaries-dialog__label-clear-filter">
        <app-bui-button-label
          [comboStyle]="'naked-link'"
          (clickEvent)="clearFilters()">
          {{'COMMON.CLEAR_ALL' | translate}}
        </app-bui-button-label>
      </div>
    </form>
  </app-dialog-template-body>
  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="'outline'"
      (clickEvent)="closeDialog()">
      {{'POPUP_FILTER_LIST_DIALOG.CANCEL' | translate}}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1"
      (clickEvent)="applySummaries()">
      {{'POPUP_FILTER_LIST_DIALOG.SAVE' | translate}}
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>

